import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateInvoiceRequest,
  GeneratedInvoice
} from '@umss/shared/data-access';

@Injectable({ providedIn: 'root' })
export class FacilityInvoiceService {
  private readonly http = inject(HttpClient);

  generate(
    facilityId: string,
    body: CreateInvoiceRequest
  ): Observable<GeneratedInvoice> {
    return this.http.post<GeneratedInvoice>(
      `/api/facilities/${facilityId}/invoices/generate`,
      body
    );
  }
}
